// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3lV1l","calendarButtons":"ClockData_calendarButtons__2gBP8"};